import { GoogleMap, Marker } from '@react-google-maps/api'
import { useCallback, useRef, useState } from 'react';
import styled from 'styled-components'
import { IoLocationSharp } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { getAdresFromLatLng } from '../../features/address/addressSlice';
import { useSelector } from 'react-redux';
import { setSelectedRouteItemUpdate } from '../../features/updateLoad/updateLoadSlice';

const Container = styled.div`
  width: 100%;
  height: 100%;

  .map-container{
    width: 100%;
    height: 100%;

    .center-marker {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%); /* Marker'ın haritanın ortasında yer almasını sağlar */
    transition: transform 0.3s ease-in-out; /* Yumuşak geçiş ekler */
    font-size: 35px;
    color: ${({isfirstChanged}) => isfirstChanged ? "#E85446" : "#989696"} ; /* Marker rengi */
    z-index: 1;
  }
  }
`

const SingleRouteMapUpdate = () => {

    const mapRef = useRef(null);
    const {getAdresFromLatLngResult} = useSelector(state => state.address);
    const { selectedRouteItemUpdate } = useSelector((state) => state.updateLoad);

    const dispatch = useDispatch();

const onMapLoad = useCallback(
  (map) => {
    mapRef.current = map;
    map.setMapTypeId("hybrid");
  },
  [mapRef]
);

    const onMapDragEnd = useCallback((map) => {
        if (mapRef.current) {
            const newCenter = mapRef.current?.getCenter()?.toJSON();
            dispatch(getAdresFromLatLng({lat: newCenter.lat, lng: newCenter.lng, isFromSingleRouteMapUpdate: true}));
            dispatch(setSelectedRouteItemUpdate({...selectedRouteItemUpdate, locationData: {...selectedRouteItemUpdate.locationData, googleLat: newCenter.lat, googleLng: newCenter.lng }}));
          }
      }, []);


  return (
    <Container isfirstChanged={selectedRouteItemUpdate.locationData.isfirstChanged}>
        <GoogleMap
            mapContainerClassName="map-container"
            center={{lat: parseFloat(selectedRouteItemUpdate.locationData.googleLat), lng: parseFloat(selectedRouteItemUpdate.locationData.googleLng)}}
            // zoom={adresSelectMapZoom}
            zoom={15}
        mapTypeId="hybrid"

            onDragEnd={(e) => onMapDragEnd(e)}
            onLoad={onMapLoad}
            options={{
                fullscreenControl: false, // Tam ekran kontrolünü kapatır
                streetViewControl: false, // Sokak görünümü kontrolünü kapatır
                mapTypeControl: false, // Harita tipi kontrolünü kapatır
                scrollwheel: false
            }}
        >
              {/* Haritanın tam ortasına marker yerleştiriliyor */}
        <div

        >


<IoLocationSharp className="center-marker" />
            
        </div>

        </GoogleMap>

    </Container>
  )
}

export default SingleRouteMapUpdate